export const MAX_LENGTH_30 = 30;
export const MAX_LENGTH_32 = 32;
export const MAX_LENGTH_20 = 20;
export const MAX_LENGTH_10 = 10;
export const MAX_LENGTH_50 = 50;
export const MAX_LENGTH_75 = 75;
export const MAX_LENGTH_100 = 100;
export const MAX_LENGTH_200 = 200;
export const MAX_LENGTH_250 = 250;
export const MAX_LENGTH_256 = 256;
export const MAX_LENGTH_300 = 300;
export const MAX_LENGTH_500 = 500;
export const MAX_LENGTH_700 = 700;
export const MAX_LENGTH_1000 = 1000;
export const MAX_LENGTH_1024 = 1024;
export const MAX_LENGTH_3000 = 3000;
export const MAX_LENGTH_14 = 14;
export const MAX_LENGTH_14_INCLUDING_SPACE = 17;
export const MAX_LENGTH_11 = 11;
export const MAX_LENGTH_12 = 12;
export const MAX_LENGTH_13 = 13;
export const MAX_LENGTH_21 = 21;
export const MAX_LENGTH_9 = 9;
export const MIN_LENGTH_3 = 3;
export const MAX_LENGTH_15 = 15;
export const MAX_LENGTH_180 = 180;
export const MAX_LENGTH_90 = 90;
export const API_STATUS_CODE = {
  NO_CONTENT: 204,
};
export const MINIMUM_TWO_PARTICIPANTS = 2;
export const MIN_FILTER_NAME_LENGTH = 3;

export const EXTENDED_SPECIAL_CHARS = "EXTENDED_SPECIAL_CHARS";

export const INPUT_LIMIT = {
  ALPHA_NUMERIC_WITH_SOME_SPECIAL_CHAR: /^(?!.*\/\.)(?!.*\.\/)(?!.*--)[a-zA-Z0-9\p{L}\p{N}\p{M} .,&/+\-_@()]*$/u,
  ALPHABETIC_WITH_SPACES_AND_HYPHEN_REGEX: /^(?!.*--)[a-zA-Z\p{L}\p{N}\p{M}\s-]*$/u,
  ALPHA_NUMERIC: /^[a-zA-Z0-9\p{L}\p{N}\p{M} ]*$/u,
  ONLY_ALPHABETS_WITH_SPACE: /^[a-zA-Z\p{L}\p{M}\s]+$/u,
  ONLY_ALPHA_NUMBER_WITH_SPACE: /^[a-z0-9A-Z\p{L}\p{N}\p{M}\s]+$/u,
  ONLY_ALPHABETS: /^[a-zA-Z\p{L}\p{M}]+$/u,
  ALPHA_NUMERIC_WITH_DASH: /^[a-zA-Z0-9\p{L}\p{N}\p{M}\-]+$/u,
  ALPHA_NUMERIC_WITH_DASH_AND_SPACE: /^(?!.*--)[a-zA-Z0-9\p{L}\p{N}\p{M}\s-]+$/u,
  ZERO_OR_MORE_ONLY_ALPHA_NUMBER_WITH_SPACE: /^[a-z0-9A-Z\p{L}\p{N}\p{M}\s]*$/u,
  ZERO_OR_MORE_ONLY_ALPHA_NUMERIC: /^[a-zA-Z0-9\p{L}\p{N}\p{M}]*$/u,
  LINK_URL: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+(com|org|net|edu|gov|mil|in|co|io|ai)(\/[^\s]*)?$/,
  NUMERIC_AND_DASH: /^[0-9\-]*$/,
  ALPHA_NUMERIC_WITH_EXTENDED_SPECIAL_CHARS: /^(?!.*",)(?!.*',)(?!.*';)(?!.*\/\.)(?!.*\.\/)(?!.*\/\*)(?!.*\*\/)(?!.*;,)(?!.*\*-)(?!.*--)[^<>]*$/,
};

export const PERSONAL_ID_REGEX = /^[A-Za-z0-9]{8}[A-Za-z]$/; // 8 alphanumeric characters followed by a letter
export const REGEX_ISO_DATE_FORMAT = /\d{4}-\d{2}-\d{2}T/;
export const REGEX_GET_FILE_NAME = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
export const REGEX_NZBN_NUMBER = /^\d{13}$/;
export const REGEX_ABN_NUMBER = /^\d{11}$/;
export const REGEX_QUALIFIED_INVOICE_NUMBER = /^\d{13}$/;
export const REGEX_BIN_NUMBER = /^\d{13}$/;
export const REGEX_SIRET_NUMBER = /^\d{3}\s\d{3}\s\d{3}\s\d{5}$/;
export const REGEX_SPANISH_VAT_NUMBER = /^ES\d{8}[A-Z]$/i;
export const REGEX_SPANISH_VAT_NUMBER_2 = /^ES[A-Z]\d{7}[A-Z]$/i;
export const REGEX_DUTCH_VAT_NUMBER = /^NL\d{9}[B]\d{2}$/i;
export const REGEX_ALLOW_NUMBER_WITH_SPACE = /[^0-9 ]/g;
export const REGEX_ONLY_NUMBER_AND_HYPHEN = /^[0-9-]+$/;
export const REGEX_ALLOW_NUMBER = /[^0-9]/g;
export const REGEX_INDIAN_CIN = /^[UL]{1}\d{5}[A-Z]{2}\d{4}(PLC|PTC)\d{6}$/i;
export const REGEX_SRI_LANKA_TIN = /^[0-9]{2}[A-Z]{2}[0-9]{5}$/i;
export const REGEX_ALPHABETS_ONLY_REMOVE_SPECIAL_CHAR_SPACE_NUMBER =
  /[^a-zA-Z]/g;
export const REGEX_ONLY_NUMBER = /^\d+$/;
export const REGEX_ALLOW_ALPHA_NUMERIC_WITHOUT_SPECIAL_CHAR = /[^A-Za-z0-9]/gi;
export const REGEX_ALLOW_ALPHABET_SPECIAL_CHAR =
  /[A-Z` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;
export const REGEX_ALLOW_SPECIAL_CHAR =
  /[` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;
export const REGEX_ALL_ZERO = /^0+$/;
export const REGEX_NUMBER_TWO_DECIMAL_PLACES = /^\d*(\.\d{0,2})?$/; // Regular expression to allow numbers with up to two decimal places
export const REGEX_CONTAINS_LETTER_NUMBER = /^(?=.*[a-zA-Z])(?=.*[0-9]).+$/;

/**
 * This regular expression replaces any special chars with blank space other than the accepted special chars
 * accepted special chars: @ . - _ +
 */
export const REGEX_EMAIL_ACCEPTED_SPECIAL_CHARS =
  /[^a-zA-Z0-9@.\-_+\p{L}\p{N}\p{M}]/gu;

/**
 * accepted special chars @ . - _ +
 * are the only special characters allowed in the email address
 */
export const REGEX_VALID_EMAIL =
  /^[a-zA-Z\p{L}\p{N}\p{M}0-9._%+-]+@[a-zA-Z\p{L}\p{N}\p{M}0-9.-]+\.[a-zA-Z\p{L}\p{N}\p{M}]{2,}$/u;

export const REGEX_FILENAME_FROM_CONTENT_DEPOSITION =
  /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

// Regex to remove characters that are not letters, spaces, or dashes (supports international names, excludes numbers)
export const REGEX_NAME_WITH_SPACES_AND_DASHES = /[^a-zA-Z\-\p{L}\p{N}\p{M} ]/gu;

// Regex to match names containing only letters, numbers, dashes, spaces, and Unicode characters (supports international names)
export const REGEX_NOT_NAME_NUMBER_AND_DASHES =
  /^[A-Za-z0-9\-\p{L}\p{N}\p{M} ]+$/u;

/**
 * For REGEX_ACCEPTED_PO_NUMBER_SPECIAL_CHARS_AND_SPACES:
 * Accepted characters: {[ (.,&/\+-_@#: )]}
 *   - Uppercase and lowercase English letters (a-z, A-Z)
 *   - Digits (0-9)
 *   - Space
 *   - Curly braces: { }
 *   - Square brackets: [ ]
 *   - Parentheses: ( )
 *   - Period (.)
 *   - Comma (,)
 *   - Ampersand (&)
 *   - Forward slash (/)
 *   - Backslash (\)
 *   - Plus (+)
 *   - Hyphen (-)
 *   - Underscore (_)
 *   - At sign (@)
 *   - Hash (#)
 *   - Colon (:)
 *
 * Not accepted characters:
 *   - Any character not listed above (e.g., !, $, %, ^, *, ', ", <, >, ?, etc.)
 */
export const REGEX_ACCEPTED_PO_NUMBER_SPECIAL_CHARS_AND_SPACES =
  /[^a-zA-Z0-9 {[().,&/\\+\-_@#:)}\]]/;

export const REGEX_ACCEPTED_OPPORTUNITY_ID_SPECIAL_CHARS_AND_SPACES =
  /[^a-zA-Z0-9{[()/\\+\-_%@#)}|\]]/;
